export default __webpack_public_path__ + "static/media/video.92540cb9.mp4";